module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-new-connection-query-2157a7f2.svg";